<template lang="pug">
  CrmLeadDetailApi(
    v-if="leadId"
    :leadId="leadId"
    :companyId="companyId"
    :stages="stages"
    :reasons="reasons"
    :users="users"
    :serviceTypes="serviceTypes"
    :canManage="canManage"
    )
</template>

<script>
import CrmLeadDetailApi from '@/components/crm/CrmLeadDetailApi.vue';

export default {
  name: 'CrmLeadDetailDrawerWrappable',
  components: { CrmLeadDetailApi },
  data() {
    return {
      leadId: null,
      companyId: null,
      stages: [],
      reasons: [],
      users: [],
      serviceTypes: [],
      // владелец компании или заместитель: правит любого клиента и удаляет
      // чужие комментарии — участнику воронки это недоступно
      canManage: false,
    };
  },
  methods: {
    init(params) {
      this.leadId = params.leadId;
      this.companyId = params.companyId;
      this.stages = params.stages ?? [];
      this.reasons = params.reasons ?? [];
      this.users = params.users ?? [];
      this.serviceTypes = params.serviceTypes ?? [];
      this.canManage = params.canManage ?? false;
    },
  },
};
</script>
